import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getCompanyInfo() {
  return request.send({
    url: `/pmy/sys/company/info`,
    method: "get",
  });
}
// 设置是否可以司机推广
export function settingPromotion(data) {
  return request.send({
    url: `/pmy/sys/company/promotion`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
